import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CommentForm } from './CommentForm';
import { FilePreview } from './FilePreview';
import { ModalWrapper, StyledRowCenter } from './styles';

import { Title } from '@/components/Typography';

interface CommentProps {
	visible?: boolean;
	loading?: boolean;
	previewImage: string;
	description?: string;
	previewType: 'image' | 'file';
	onConfirm: (value: string) => void;
	onCancel: () => void;
}

const { useForm } = Form;

export function Comment({
	visible = false,
	loading = false,
	previewType,
	previewImage,
	description,
	onConfirm,
	onCancel
}: Readonly<CommentProps>) {
	const [form] = useForm<{ comment: string }>();

	function handleOnFinish(): void {
		const values = form.getFieldsValue(true);
		onConfirm(values.comment);
	}

	return (
		<ModalWrapper open={visible} centered footer={false} destroyOnClose onCancel={onCancel}>
			<Form form={form} initialValues={{ comment: description }} layout="vertical">
				<StyledRowCenter gutter={[0, 20]}>
					<Col span={24}>
						<Title level={3}>{I18n.get('Add description')}</Title>
					</Col>
					<FilePreview previewType={previewType} previewImage={previewImage} />
					<CommentForm onFinish={handleOnFinish} onCancel={onCancel} loading={loading} />
				</StyledRowCenter>
			</Form>
		</ModalWrapper>
	);
}
